import { FC } from 'react';
import { LinearProgress } from '@mui/material';

export const StatsBlock: FC<{
  current: number;
  total?: number;
}> = ({ current, total }) => {
  const progress = total ? getProgressValue(current, total) : null;

  return (
    <div className="flex flex-col basis-1/2">
      <div className="grow mx-1 justify-center relative">
        {total && total > 0 && progress !== null ? (
          <div className="relative">
            <span className="text-xs absolute z-10 top-1 left-2 text-white">
              {(current * 100) / total}%
            </span>
            <span className="text-xs text-gray-700">{total}</span>
            <LinearProgress
              variant="determinate"
              value={progress < 100 ? progress : 100}
              color={getProgressColor(progress) as any}
              sx={{
                visibility:
                  total && total > 0 && progress !== null
                    ? 'visible'
                    : 'hidden',
                height: 24,
                borderRadius: '12px',
                '& .MuiLinearProgress-bar': {
                  borderRadius: '1rem',
                },
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
              }}
            />
          </div>
        ) : null}

        <div className="flex grow justify-between items-center bg-slate-100 rounded-xl px-2 mt-2 h-6">
          {total && total > 0 ? (
            <>
              <span className="text-xs text-gray-700">{current}</span>
              <span className="text-xs text-gray-700">{total}</span>
            </>
          ) : (
            <span className="text-xs text-gray-700">{current}</span>
          )}
        </div>
      </div>
    </div>
  );
};

const getProgressValue = (current: number, total: number) =>
  (current / total) * 100;

const getProgressColor = (progress: number) => {
  let result;

  if (progress < 40) {
    result = 'success';
  } else if (progress > 40 && progress < 70) {
    result = 'warning';
  } else {
    result = 'error';
  }

  return result;
};
